
export const STAR_POINT_REQUEST = "starshop/STAR_POINT_REQUEST";
export const STAR_POINT_SUCCESS = "starshop/STAR_POINT_SUCCESS";
export const STAR_POINT_FAILURE = "starshop/STAR_POINT_FAILURE";

export const PRODUCT_LIST_REQUEST = "starshop/PRODUCT_LIST_REQUEST";
export const PRODUCT_LIST_SUCCESS = "starshop/PRODUCT_LIST_SUCCESS"
export const PRODUCT_LIST_FAILURE = "starshop/PRODUCT_LIST_FAILURE"

export const POINT_USELIST_REQUEST = "starshop/POINT_USELIST_REQUEST";
export const POINT_USELIST_SUCCESS = "starshop/POINT_USELIST_SUCCESS"
export const POINT_USELIST_FAILURE = "starshop/POINT_USELIST_FAILURE"

export const POINT_SAVELIST_REQUEST = "starshop/POINT_SAVELIST_REQUEST";
export const POINT_SAVELIST_SUCCESS = "starshop/POINT_SAVELIST_SUCCESS"
export const POINT_SAVELIST_FAILURE = "starshop/POINT_SAVELIST_FAILURE"


export const SET_GOALS_REQUEST = "starshop/SET_GOALS_REQUEST";
export const SET_GOALS_SUCCESS = "starshop/SET_GOALS_SUCCESS"
export const SET_GOALS_FAILURE = "starshop/SET_GOALS_FAILURE"

export const GET_GOALS_REQUEST = "starshop/GET_GOALS_REQUEST";
export const GET_GOALS_SUCCESS = "starshop/GET_GOALS_SUCCESS";
export const GET_GOALS_FAILURE = "starshop/GET_GOALS_FAILURE";

export const DELETE_TARGET_REQUEST = "starshop/DELETE_TARGET_REQUEST";
export const DELETE_TARGET_SUCCESS = "starshop/DELETE_TARGET_SUCCESS";
export const DELETE_TARGET_FAILURE = "starshop/DELETE_TARGET_FAILURE";

export const EXCHANGE_PRODUCT_REQUEST = "starshop/EXCHANGE_PRODUCT_REQUEST";
export const EXCHANGE_PRODUCT_SUCCESS = "starshop/EXCHANGE_PRODUCT_SUCCESS";
export const EXCHANGE_PRODUCT_FAILURE = "starshop/EXCHANGE_PRODUCT_FAILURE";

export const EXCHANGE_HISTORY_REQUEST = "starshop/EXCHANGE_HISTORY_REQUEST";
export const EXCHANGE_HISTORY_SUCCESS = "starshop/EXCHANGE_HISTORY_SUCCESS";
export const EXCHANGE_HISTORY_FAILURE = "starshop/EXCHANGE_HISTORY_FAILURE";

export const RESEND_PRODUCT_REQUEST = "starshop/RESEND_PRODUCT_REQUEST";
export const RESEND_PRODUCT_SUCCESS = "starshop/RESEND_PRODUCT_SUCCESS";
export const RESEND_PRODUCT_FAILURE = "starshop/RESEND_PRODUCT_FAILURE";

export const PROFILE_PHOTO_REQUEST = "starshop/PROFILE_PHOTO_REQUEST";
export const PROFILE_PHOTO_SUCCESS = "starshop/PROFILE_PHOTO_SUCCESS";
export const PROFILE_PHOTO_FAILURE = "starshop/PROFILE_PHOTO_FAILURE";

export const MMBR_TYPE_REQUEST = "starshop/MMBR_TYPE_REQUEST"
export const MMBR_TYPE_SUCCESS = "starshop/MMBR_TYPE_SUCCESS"
export const MMBR_TYPE_FAILURE = "starshop/MMBR_TYPE_FAILURE"

export const PASS_TARGET_ARRAY = "starshop/PASS_TARGET_ARRAY"

